/**
 * @deprecated
 */
export function autoBind(instance?: any) {
  return function autoBinding(_target: any, _propertyKey: string | symbol, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;

    if (typeof originalMethod !== 'function') {
      throw new Error('autoBind can only be applied to methods.');
    }

    return {
      configurable: true,
      get() {
        return originalMethod.bind(instance ?? this);
      },
    };
  };
}
